var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.otherAddresses
    ? _c(
        "Modal",
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c("Title", {
                attrs: { title: "Selecione o local da limpeza para continuar" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "body" },
            [
              _c("Address", {
                attrs: { address: _vm.address },
                on: {
                  addressSelected: function($event) {
                    _vm.$emit("onAddressSelection")
                  }
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text" }, [_vm._v("ou")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "other",
                  on: {
                    click: function($event) {
                      _vm.otherAddresses = true
                    }
                  }
                },
                [_vm._v("\n      Outro endereço\n    ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "button",
              {
                staticClass: "btn bg-outlined",
                on: {
                  click: function($event) {
                    _vm.$emit("onReturn")
                  }
                }
              },
              [_c("span", [_vm._v("Voltar")])]
            )
          ])
        ],
        2
      )
    : _c("Addresses", {
        on: {
          addressSelection: function($event) {
            _vm.$emit("onAddressSelection")
          }
        }
      })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8049514", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8049514","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order/Components/Actions/Professional/Address.vue
// module id = null
// module chunks = 